import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ExportLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 5-.354-.354.354-.353.354.353zm.5 9a.5.5 0 0 1-1 0zM6.646 9.646l5-5 .708.708-5 5zm5.708-5 5 5-.708.708-5-5zM12.5 5v9h-1V5z" }),
            React.createElement("path", { stroke: "currentColor", d: "M5 16v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1" })));
}
const ExportLight = forwardRef(_ExportLight);
export { ExportLight };
